export function getCookie(cookieName) {
    const cookieString = document.cookie
    const cookies = cookieString.split('; ')

    for (const cookieItem of cookies) {
        const cookie = cookieItem.split('=')
        const name = decodeURIComponent(cookie[0])
        const value = decodeURIComponent(cookie[1])

        if (name === cookieName) {
            return value
        }
    }

    return ''
}

export function setCookie(cookieName, cookieValue) {
    //SETS TO cinestar.cz to share cookie between subdomains in production
    const mainDomain = process.env.REACT_APP_BASE_WEBSALE_TOP_DOMAIN
    if (!mainDomain) {
        console.error('no base url')
    }
    let cookieString = `${encodeURIComponent(cookieName)}=${encodeURIComponent(cookieValue)}`

    //Localhost should not use top domain
    if (location.hostname !== 'localhost' || location.hostname === '127.0.0.1') {
        cookieString += `; domain=${mainDomain}`
    }
    document.cookie = cookieString
}
